module.exports = __webpack_public_path__ + "static/media/aave.8eb84c21.svg";